export enum AppPermissions {
  CONTACT_REQUESTS_READ = "Solicitudes de Contacto - Lectura",
  CONTACT_REQUESTS_WRITE = "Solicitudes de Contacto - Escritura",
  USERS_READ = "Usuarios - Lectura",
  USERS_WRITE = "Usuarios - Escritura",
  ROLES_READ = "Roles y Permisos - Lectura",
  ROLES_WRITE = "Roles y Permisos - Escritura",
  USER_ROLES_READ = "Asignación de roles - Lectura",
  USER_ROLES_WRITE = "Asignación de roles - Escritura",
  ACCOUNTS_READ = "Cuentas - Lectura",
  ACCOUNTS_WRITE = "Cuentas - Escritura",
  PERSONS_READ = "Personas - Lectura",
  PERSONS_WRITE = "Personas - Escritura",
  CBU_READ = "CBU - Lectura",
  CBU_WRITE = "CBU - Escritura",
  //Solicitudes
  CASH_REQUEST_READ = "Solicitud Efectivo - Lectura",
  CASH_REQUEST_WRITE = "Solicitud Efectivo - Escritura",

  CHECK_REQUEST_READ = "Solicitud Cheque - Lectura",
  CHECK_REQUEST_WRITE = "Solicitud Cheque - Escritura",

  TRANSFER_REQUEST_READ = "Solicitud Transferencia - Lectura",
  TRANSFER_REQUEST_WRITE = "Solicitud Transferencia - Escritura",

  SCHEDULED_TRANSFER_READ = "Transferencias Programadas - Lectura",
  SCHEDULED_TRANSFER_WRITE = "Transferencias Programadas - Escritura",

  //Configuración
  PRICE_BOARD_READ = "Mercado del día - Lectura",
  PRICE_BOARD_WRITE = "Mercado del día - Escritura",

  REQUEST_POLICIES_READ = "Políticas de negocio - Lectura",
  REQUEST_POLICIES_WRITE = "Políticas de negocio - Escritura",

  MOTIVES_READ = "Motivos - Lectura",
  MOTIVES_WRITE = "Motivos - Escritura",

  RELATION_FIELDS_READ = "Campos relaciones familiares - Lectura",
  RELATION_FIELDS_WRITE = "Campos relaciones familiares - Escritura",

  FINANCIAL_MOVEMENTS_DESC_READ = "Descripcion de movimientos financieros - Lectura",
  FINANCIAL_MOVEMENTS_DESC_WRITE = "Descripcion de movimientos financieros - Escritura",

  APP_MAINTENANCE_READ = "Gestión mantenimiento mobile - Lectura",
  APP_MAINTENANCE_WRITE = "Gestión mantenimiento mobile - Escritura",

  TRUCKS_READ = "Maestro de camiones - Lectura",
  TRUCKS_WRITE = "Maestro de camiones - Escritura",
  
  LOGISTIC_READ = "Logística completa - Lectura",
  LOGISTIC_WRITE = "Logística completa - Escritura",
  //Solicitudes granarias
  SELL_ORDER_READ = "Orden de Venta - Lectura",
  SELL_ORDER_WRITE = "Orden de Venta - Escritura",

  COUNTER_DELIVERY_READ = "Contra Entrega - Lectura",
  COUNTER_DELIVERY_WRITE = "Contra Entrega - Escritura",

  GRAIN_FUTURE_CONTRACTS_READ = "Contratos futuros - Lectura",
  GRAIN_FUTURE_CONTRACTS_WRITE = "Contratos futuros - Escritura",

  SLOT_REQUESTS_READ = "Solicitud de Cupos - Lectura",
  SLOT_REQUESTS_WRITE = "Solicitud de Cupos - Escritura",

  TAXES_LOAD_READ = "Carga de impuestos - Lectura",
  TAXES_LOAD_WRITE = "Carga de impuestos - Escritura",
}

export enum PermissionCode {
  // Usuarios y contactos
  USERS = "USERS",
  CONTACT_REQUESTS = "CONTACT_REQUEST",

  // Roles y permisos
  ROLES_PERMISSIONS = "ROLES_PERMISSIONS",
  ROLE_ASSIGNATION = "ROLE_ASSIGNATION",

  // Cuentas y personas
  ACCOUNTS = "ACCOUNTS",
  CBU = "ACCOUNTS_CBU",
  PERSONS = "PERSONS",

  // Solicitudes
  CASH_REQUEST = "CASH_REQUEST",
  CHECK_REQUEST = "CHECK_REQUEST",
  TRANSFER_REQUEST = "TRANSFER_REQUEST",
  SCHEDULED_TRANSFER = "SCHEDULED_TRANSFER",
  EXTERNAL_TRANSFER = "EXTERNAL_TRANSFER_REQUEST",

  // Solicitudes granarias
  GRAIN_SELL_ORDER = "GRAIN_SELL_ORDER",
  COUNTER_DELIVERY = "COUNTER_DELIVERY",
  GRAIN_FUTURE_CONTRACT = "GRAIN_FUTURE_CONTRACT",
  SLOT_REQUESTS = "SLOT_REQUESTS",
  // Configuración
  MARKET_CONFIG = "MARKET_CONFIG",
  BUSINESS_POLICY = "BUSINESS_POLICY",
  MOTIVES = "MOTIVES",
  FAMILY_RELATIONS_FIELDS = "FAMILY_RELATIONS_FIELDS",
  FINANCIAL_MOVEMENTS_DESC = "FINANCIAL_MOVEMENTS_DESC",
  BACKUP_CHECKS = "BACKUP_CHECKS",
  APP_MAINTENANCE = "APP_MAINTENANCE",
  TRUCKS = "TRUCKS",
  DRIVERS = "DRIVERS",
  LOGISTIC = "LOGISTIC",
  TECHNICIANS = "TECHNICIANS",
  NOTIFICATION_TYPES = "NOTIFICATION_TYPES",
  TAXES_LOAD = "TAXES_LOAD",
  //Insumos
  PRODUCTS = "PRODUCTS",
  FERT_SLOTS_REQ = "FERT_SLOTS_REQ",
  FUEL_SLOTS_REQ = "FUEL_SLOTS_REQ",
  PURCHASE_ORDER_INTENT = "PURCHASE_ORDER_INTENT",

  //Producción ATA y RsaTyG
  FIELD_VISIT = "FIELD_VISIT",

  SAMPLING_REQUESTS = "SAMPLING_REQUESTS",
  FLIGHT_REQUESTS = "FLIGHT_REQUESTS",
  
  PRODUCT_PLANIFICATION = "PRODUCT_PLANIFICATION",

  GROSS_MARGIN_REQUESTS = "GROSS_MARGIN_REQUESTS",
  ESTABLISHMENTS_FIELDS = "ESTABLISHMENTS_FIELDS",
  ESTABLISHMENTS_FIELDS_REQUESTS = "ESTABLISHMENTS_FIELDS_REQUESTS",

  //Maestros Producción
  PRODUCTION_GRAINS = "PRODUCTION_GRAINS",
  PRODUCTION_ZONES = "PRODUCTION_ZONES",
  ZONAL_GROSS_MARGIN = "ZONAL_GROSS_MARGIN",

  //Onboarding Jurídico
  LEGAL_ONBOARDING = "LEGAL_ONB",


}
